import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IVendorModel } from '../../../pages/UpdateVendor/interfaces';

export const useGetVendorList = () => {
  const user = useStore(state => state.user);
  const getPersonalAccount = useStore(state => state.getPersonalAccount);
  const { accountExternalId } = getPersonalAccount();
  const { customerId } = user;
  return useQuery(
    'GetVendorList',
    async () => {
      const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/supplier`);
      return res.data.suppliers as IVendorModel[];
    },
    {
      enabled: false,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  );
};
